<template>
  <div class=" card-header text-center paymentMethod " >
    <h5>انتخاب نحوه پرداخت</h5>
  </div>
  <div class="card-body paymentMethod" style="overflow: auto; height: 783px;">
    <div class="d-flex flex-column justify-content-center">
      <div class="p-2">
        <ul class="list-group">
          <li class="list-group-item"><i class="fa fa-exclamation-triangle ms-2 text-warning"></i>
            تولید کدهای تخفیف ممکن است تا 30 دقیقه پس از تکمیل خرید زمان ببرد
          </li>
          <li class="list-group-item"><i class="fa fa-exclamation-triangle ms-2 text-warning "></i>
            درصورت بروز مشکل یا سوال با واحد نمایندگی تماس بگیرید و یا در تلگرام فروش آنلاین پیام دهید: 09045294338

          </li>
          <li class="list-group-item"><i class="fa fa-exclamation-triangle ms-2 text-warning "></i>
            برای پیگیری خریدهای خود حتما کد پیگیری در پایان خرید را یادداشت کنید
          </li>
          <li class="list-group-item"><i class="fa fa-exclamation-triangle ms-2 text-danger "></i>
            با انتخاب پرداخت اعتباری شما فرصت دارید در بازه مشخص شده پرداخت خود را انجام دهید.
          </li>
          <li class="list-group-item"><i class="fa fa-exclamation-triangle ms-2 text-danger "></i>
            با انتخاب پرداخت آنلاین تخفیف بیشتری برای شما درنظر گرفته خواهد شد
          </li>

        </ul>
      </div>
    </div>
    <br>
    <div class="d-flex flex-row  justify-content-center ">
      <div class="p-2 ">

        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" @change="checkRules()">
          <h5 class="form-check-label text-danger " for="flexSwitchCheckDefault">قوانین مربوط به تعهدات نمایندکی شرکت مهندسی نرم افزار هلو را خوانده و آن را می پذیرم.</h5>
        </div>

      </div>
    </div>
    <div class="d-flex flex-row  justify-content-center ">
      <div class="p-2" v-if="rules === true">
        <div class="d-flex flex-column justify-content-center ">
          <div class="p-2 text-center font-weight-bold"><h6>لطفا نوع پرداخت خود را مشخص کنید</h6></div>
        </div>
        <select class="form-control form-select"  v-model="selectionValue" @change="selectionPayment($event)">
          <option value="credit"> پرداخت اعتباری(ثبت و پرداخت در آینده)</option>
          <option value="payment">پرداخت آنلاین</option>
        </select>
      </div>
    </div>
    <div v-if="rules === true && rules === true">
      <caredit v-if="selectionValue === 'credit'"/>
      <payment v-else-if="selectionValue === 'payment'"/>
    </div>
  </div>

</template>
<script setup>
import caredit from "@/agent/components/checkout/credit.vue"
import payment from "@/agent/components/checkout/payment.vue"
import {$ref} from "vue/macros";
import {useStore} from 'vuex'

const store = useStore()
let selectionValue = $ref()
let rules = $ref('false');

function selectionPayment(e) {
  store.dispatch('statusType', {'status': selectionValue});
  return selectionValue
}
function checkRules() {
  if (rules === true) {
    selectionValue = "";
    return rules = false;

  } else {
    return rules = true;
  }
}
</script>
